import { memo } from 'react';

import Tooltip from '@/components/mui/Tooltip';
import type { DisplayedOcrPolygon } from '@/pages/document/DocumentViewer/DocumentFileView/PageView/PageOcrLayer/ocrGeometry';
import { OcrWordRoot } from '@/pages/document/DocumentViewer/DocumentFileView/PageView/PageOcrLayer/OcrWords/OcrWord/StyledComponents';

type Props = {
  word: DisplayedOcrPolygon;
  /** The word's place among the page's OCR words; the layer reads it back from the element. */
  index: number;
};

const OcrWord = ({ word: { left, top, width, height, text }, index }: Props) => (
  <OcrWordRoot
    role="toolbar"
    draggable="false"
    style={{ left, top, width, height }}
    data-document-drag-handle
    data-ocr-word-index={index}
  >
    <Tooltip t={text} placement="top" disableInteractive>
      <div style={{ width, height }} />
    </Tooltip>
  </OcrWordRoot>
);

export default memo(OcrWord);
